@if (openCount() > 0) {
  <section class="rounded-xl border border-base-300 bg-base-100 overflow-hidden">

    <header class="flex items-center gap-2 border-b border-base-300 px-4 py-3">
      <h2 class="text-sm font-semibold tracking-tight">Quick check</h2>
      <span class="badge badge-sm badge-warning badge-soft ms-auto">{{ openCount() }}</span>
    </header>

    <div class="flex flex-col gap-3 p-4">
      @for (row of rows(); track trackRow($index, row)) {
        <div class="flex items-center gap-3 text-sm">
          <div class="h-8 w-8 shrink-0 overflow-hidden rounded-md border border-base-300 bg-base-200">
            <img
              class="h-full w-full object-contain"
              [src]="row.check.stock?.thumbImageUrl || placeholderImage(row)"
              alt=""
              loading="lazy"/>
          </div>
          <span class="truncate">{{ row.check.stock?.productName }}</span>
          <span class="ms-auto shrink-0 text-xs text-base-content/60">{{ ageLabel(row) }}</span>
        </div>
      }

      <ui-button variant="primary" size="sm" fullWidth [routerLink]="['/quick-check']">
        @if (openCount() === 1) {
          Answer 1 question
        } @else {
          Answer {{ openCount() }} questions
        }
      </ui-button>
    </div>
  </section>
}
